import { render } from "./PageControl.vue?vue&type=template&id=31891a04&scoped=true"
import script from "./PageControl.vue?vue&type=script&lang=js"
export * from "./PageControl.vue?vue&type=script&lang=js"

import "./PageControl.vue?vue&type=style&index=0&id=31891a04&scoped=true&lang=css"

import exportComponent from "D:\\My Project\\NewBlog\\WEB\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31891a04"]])

export default __exports__